require('./hubspot.scss')
var $ = require('jquery');

module.exports = function(form) {

  $('> [data-reactid]', form).each(function() {
    var $field = $(this),
      $input = $('[name]', $field);

    $field.addClass($input.attr('name'));

    //checkboxes
    if ($('.hs-form-checkbox', $field).length) {
      $field.addClass('hs-field__checkbox');
    }
    if ($('.hs-form-booleancheckbox', $field).length) {
      $field.addClass('hs-field__checkbox--boolean');
    }

    //radios
    if ($('.hs-form-radio', $field).length) {
      $field.addClass('hs-field__radio');
    }

    //select dropdown
    if ($('select', $field).length) {
      $field.addClass('hs-field__select');
      $field.find('select').parent('.input').addClass('hs-field__select-input');
    }
  });
};
